import { DestroyRef, inject, Injectable } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

@Injectable({
  providedIn: "root",
})
export class ModalService {
  private readonly destroyRef = inject(DestroyRef);

  private readonly DEFAULT_DIALOG_CONFIG: MatDialogConfig = {
    id: "modal-component",
    minWidth: "40vw",
    maxHeight: "90vh",
    hasBackdrop: true,
    panelClass: "dialog-background",
    backdropClass: "dialog-overlay",
    disableClose: false,
    width: "720px",
  };

  constructor(private readonly matDialog: MatDialog) {}

  public async openDialog(
    component: any,
    dialogData?: any,
    dialogConfig?: any,
  ) {
    let currentDialogConfig = this.DEFAULT_DIALOG_CONFIG;

    if (dialogConfig !== undefined) {
      currentDialogConfig = { ...currentDialogConfig, ...dialogConfig };
    }
    if (dialogData !== undefined) {
      currentDialogConfig.data = dialogData;
    }

    const minWidth = window.innerWidth < 2000 ? "40vw" : "auto";
    currentDialogConfig.minWidth = minWidth;

    this.matDialog.open(component, currentDialogConfig);
  }

  public openDialogWithCallbackHandler(
    component: any,
    dialogData?: any,
    afterClosedHandler?: (result) => void,
    dialogConfig?: any,
  ) {
    const modalDialog = this.matDialog.open(
      component,
      this.getMatDialogConfig(dialogData, dialogConfig),
    );
    modalDialog
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        afterClosedHandler(result);
      });
  }

  private getMatDialogConfig(
    dialogData?: any,
    dialogConfig?: any,
  ): MatDialogConfig {
    // Create a copy to avoid mutating the default config
    let defaultDialogConfig = { ...this.DEFAULT_DIALOG_CONFIG };

    if (dialogConfig !== undefined) {
      defaultDialogConfig = { ...defaultDialogConfig, ...dialogConfig };
    }

    if (dialogData !== undefined) {
      defaultDialogConfig.data = dialogData;
      defaultDialogConfig.disableClose = dialogData.disableClose;
    }

    const minWidth = window.innerWidth < 2000 ? "40vw" : "auto";
    defaultDialogConfig.minWidth = minWidth;

    return defaultDialogConfig;
  }
}
